import AuthService from '../services/auth.service';
import TokenService from '../services/token.service';
import router from '@/router';

const user = JSON.parse(localStorage.getItem('user'));
const impersonationOrigin = TokenService.getImpersonationOrigin();
const initialState = user
    ? { status: { loggedIn: true }, user, impersonationOrigin }
    : { status: { loggedIn: false }, user: null, impersonationOrigin: null };

export const auth = {
    namespaced: true,
    state: initialState,
    getters: {
        isImpersonating: (state) => state.impersonationOrigin !== null,
    },
    actions: {
        async login({ commit }, user) {
            const response = await AuthService.login(user).catch(
                error => {
                    commit('loginFailure');
                    return Promise.reject(error);
                }
            );

            await commit('loginSuccess', response);
            router.push({ name: 'dashboard'});
        },
        logout({ commit }) {
            AuthService.logout();
            TokenService.clearImpersonationOrigin();
            commit('logout');

            router.push({ name: 'Login'});
        },
        async impersonate({ commit, state }, impersonationToken) {
            if (state.status.loggedIn && state.user) {
                TokenService.saveImpersonationOrigin(state.user);
                commit('startImpersonating', state.user);
            }

            const response = await AuthService.impersonate(impersonationToken).catch(
                error => {
                    TokenService.clearImpersonationOrigin();
                    commit('stopImpersonating');
                    commit('loginFailure');
                    return Promise.reject(error);
                }
            );

            await commit('loginSuccess', response);
            router.push({ name: 'dashboard'});
        },
        stopImpersonating({ commit, state }) {
            const origin = state.impersonationOrigin;

            if (!origin) {
                return;
            }

            TokenService.setUser(origin);
            TokenService.clearImpersonationOrigin();
            commit('stopImpersonating');
            commit('loginSuccess', origin);

            // Full reload so every module (biens, sci, etc.) refetches data for the restored user
            // instead of keeping the impersonated user's data in memory.
            window.location.href = router.resolve({ name: 'dashboard' }).href;
        },
        refreshToken({ commit }, token) {
            commit('refreshToken', token);
        }
    },
    mutations: {
        loginSuccess(state, user) {
            state.status.loggedIn = true;
            state.user = user;
        },
        loginFailure(state) {
            state.status.loggedIn = false;
            state.user = null;
        },
        logout(state) {
            state.status.loggedIn = false;
            state.user = null;
            state.impersonationOrigin = null;
        },
        registerSuccess(state) {
            state.status.loggedIn = false;
        },
        registerFailure(state) {
            state.status.loggedIn = false;
        },
        refreshToken(state, token) {
            state.status.loggedIn = true;
            state.user = { ...state.user, token: token };
        },
        startImpersonating(state, origin) {
            state.impersonationOrigin = origin;
        },
        stopImpersonating(state) {
            state.impersonationOrigin = null;
        }
    }
};